import { supabase } from "../supabaseClient";

export const FEATURED_EVENTS_STORAGE_KEY = "echo_jham_featured_events";
const FEATURED_EVENTS_STORAGE_BUCKET = "event-images";
const FEATURED_EVENTS_STORAGE_PATH = "featured/featured-events.json";
export const FEATURED_EVENTS_LIMIT = 3;
export const FEATURED_EVENTS_UPDATED_EVENT = "echo_jham_featured_events_updated";

const normalizeFeaturedItems = (items) => {
  return (Array.isArray(items) ? items : [])
    .map((item) => ({
      eventId: String(item?.eventId || ""),
      bannerUrl: String(item?.bannerUrl || ""),
      updatedAt: String(item?.updatedAt || new Date().toISOString()),
    }))
    .filter((item) => item.eventId)
    .slice(0, FEATURED_EVENTS_LIMIT);
};

export const readFeaturedEventsConfig = () => {
  try {
    const raw = localStorage.getItem(FEATURED_EVENTS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];

    if (!Array.isArray(parsed)) return [];

    return parsed
      .map((item) => ({
        eventId: String(item?.eventId || ""),
        bannerUrl: String(item?.bannerUrl || ""),
        updatedAt: String(item?.updatedAt || ""),
      }))
      .filter((item) => item.eventId);
  } catch (error) {
    console.error("Failed to parse featured events configuration:", error);
    return [];
  }
};

export const loadFeaturedEventsConfig = async () => {
  try {
    const { data, error } = await supabase.storage
      .from(FEATURED_EVENTS_STORAGE_BUCKET)
      .download(FEATURED_EVENTS_STORAGE_PATH);

    if (error || !data) {
      const isMissingObject =
        String(error?.statusCode || "") === "404" ||
        /not found|object not found/i.test(String(error?.message || ""));

      if (isMissingObject) {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem(FEATURED_EVENTS_STORAGE_KEY, JSON.stringify([]));
        }
        return [];
      }

      return readFeaturedEventsConfig();
    }

    const text = await data.text();
    const parsed = text ? JSON.parse(text) : [];
    const normalized = normalizeFeaturedItems(parsed);

    if (typeof localStorage !== "undefined") {
      localStorage.setItem(FEATURED_EVENTS_STORAGE_KEY, JSON.stringify(normalized));
    }

    return normalized;
  } catch (error) {
    console.error("Failed to load featured events from Supabase storage:", error);
    return readFeaturedEventsConfig();
  }
};

export const writeFeaturedEventsConfig = async (items) => {
  const normalized = normalizeFeaturedItems(items);

  try {
    const payload = new Blob([JSON.stringify(normalized, null, 2)], {
      type: "application/json",
    });

    const { error } = await supabase.storage
      .from(FEATURED_EVENTS_STORAGE_BUCKET)
      .upload(FEATURED_EVENTS_STORAGE_PATH, payload, {
        upsert: true,
        contentType: "application/json",
      });

    if (error) {
      throw error;
    }
  } catch (error) {
    console.error("Failed to save featured events to Supabase storage:", error);
    throw error;
  }

  localStorage.setItem(FEATURED_EVENTS_STORAGE_KEY, JSON.stringify(normalized));

  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(FEATURED_EVENTS_UPDATED_EVENT));
  }

  return normalized;
};
